import React from 'react';
import LegalPage from '../components/LegalPage';
import { refundPolicy } from '../data/legal';

export default function RefundPolicyPage() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="Refund Policy"
      updated={refundPolicy.updated}
      body={refundPolicy.body}
      testId="refund-policy-page"
    />
  );
}
